import { observable, action } from 'mobx';
import Turnus from 'src/models/Turnus';
import { IApiService } from 'src/services/IApiService';

export default class TurnusStore {
    @observable public turnuses: Turnus[] = [];
    public turnusyByKlientID: Map<number, Turnus[]> = new Map();
    public turnusyByObjednavkaID: Map<number, Turnus[]> = new Map();

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public loadForClient(clientId: number) {
        this.turnuses = [];
        this.api.getKlientTurnus(clientId).then(a => a.map(turnus => {
            this.turnuses.push(turnus);
        }));
    }

    public loadAll(): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getTurnusyAll().then(turnusy => {
                turnusy.forEach(turnus => {
                    this.addTurnus(turnus);
                });
                resolve(true);
            });
        })
    }

    public addTurnus(turnus: Turnus) {
        if(this.turnusyByKlientID.has(turnus.idKlient)) {
            this.turnusyByKlientID.get(turnus.idKlient).push(turnus);
        } else {
            this.turnusyByKlientID.set(turnus.idKlient, []);
            this.turnusyByKlientID.get(turnus.idKlient).push(turnus);
        }
        if(this.turnusyByObjednavkaID.has(turnus.idObjednavka)) {
            this.turnusyByObjednavkaID.get(turnus.idObjednavka).push(turnus);
        } else {
            this.turnusyByObjednavkaID.set(turnus.idObjednavka, []);
            this.turnusyByObjednavkaID.get(turnus.idObjednavka).push(turnus);
        }
    }

    private removeTurnusForClient(turnus: Turnus) {
        if(this.turnusyByKlientID.has(turnus.idKlient)) {
            const turnusy = this.turnusyByKlientID.get(turnus.idKlient);

            const index = turnusy.findIndex(a => a.id === turnus.id);
            if(index >= 0) {
                turnusy.splice(index, 1);
            }
        }
    }

    public removeLocalTurnusesByObjednavkaID(objednavkaId: number) {
        const toDelete = this.getTurnusyByObjednavkaID(objednavkaId);
        toDelete.forEach(trn => {
            const index = this.turnuses.findIndex(a => a.id === trn.id);
            if(index >= 0) {
                this.turnuses.splice(index, 1);
            }
            this.removeTurnusForClient(trn);
        });
    }

    public getTurnusyByObjednavkaID(objednavkaId: number): Turnus[] {
        if(this.turnusyByObjednavkaID.has(objednavkaId)) {
            return this.turnusyByObjednavkaID.get(objednavkaId);
        }
        return [];
    }

    public getTurnusyByKlientID(clientId: number): Turnus[] {
        if(this.turnusyByKlientID.has(clientId)) {
            return this.turnusyByKlientID.get(clientId);
        }
        return [];
    }

    @action
    public createNewTurnus(turnus: Turnus) {
        this.api.createNewTurnus(turnus).then(trns => {
            this.turnuses.push(trns);
            this.addTurnus(trns);
        });
    }

    @action
    public createNewTurnusRaw(clientId: number, from: Date, to: Date, prg: number, state: string) {
        const toInsert = new Turnus();
        toInsert.idKlient = clientId;
        toInsert.od = from;
        toInsert.do = to;
        toInsert.program = prg;
        this.api.createNewTurnus(toInsert).then(turnus => {
            this.turnuses.push(turnus);
            this.addTurnus(turnus);
        });
    }

    @action
    public updateTurnus(turnus: Turnus): Promise<Turnus> {
        return new Promise(resolve => {
          this.api.updateTurnus(turnus)
            .then(turnu => {
              resolve(turnu);
            });
        });

    }

    @action
    public deleteTurnus(turnus: Turnus) {
        return new Promise(resolve => {
          this.api.deleteTurnus(turnus)
            .then(turn => {
                const index = this.turnuses.findIndex(a => a.id === turn.id);
                if(index >= 0) {
                    this.turnuses.splice(index, 1);
                }
                this.removeTurnusForClient(turn);
                resolve(turn);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/TurnusStore.tsx